export default __webpack_public_path__ + "static/media/tut3novoville.6b0068ea.png";